import React from "react";
import Overlay from "./Overlay";

interface OverlayContactHostProps {
  hostPhoneNumber: string;
  isOpen: boolean;
  onClose: () => void;
}

export const OverlayContactHost: React.FC<OverlayContactHostProps> = ({ hostPhoneNumber, isOpen, onClose }) => {
  const handleWhatsAppHost = () => {
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${hostPhoneNumber.replace(/\+/g, '')}&text&type=phone_number&app_absent=0`;
    window.open(whatsappUrl, "_blank");
  };

  const handleTextHost = () => {
    const smsUrl = `sms:${hostPhoneNumber}`;
    window.open(smsUrl);
  };

const buttons = [
      { text: "WhatsApp the host", onClick: handleWhatsAppHost, image:"/assets/img/contactButtonWhatsapp.svg" },
      { text: "Text the host", onClick: handleTextHost, image:"/assets/img/contactButtonSms.svg" },
    ];

  return (
    <Overlay title="Contact Host" isOpen={isOpen} onClose={onClose} buttons={buttons}>
    </Overlay>
  );
};